module.exports = __webpack_public_path__ + "img/debt_assist_icon.cf205f16.svg";